<div class="sh-form-check-dropdown-wrapper" (shClickOutside)="setDropdownClosed()">
  <sh-droppanel-select
    [id]="id"
    [options]="selectOptions$ | async"
    [initialSelectedValues]="selectedValues$ | async"
    [allowSingleDeselect]="false"
    [droppanelStyle]="droppanelStyle"
    [inOverflownContainer]="inOverflownContainer"
    [isOpen$]="isOpen$"
    (selectionState)="onSelectionStateChange($event)"
    >
    <div [ngClass]="[inverted ? 'sh-form-check-with-icon--inverted' : 'sh-form-check-with-icon', disabled ? '-sh-disabled' : '']">
      <div class="sh-form-check-with-icon__check" (click)="toggleDropdown($event)" (keydown.enter)="toggleDropdown($event)">
        <input
          #checkboxEl
          type="checkbox"
          [formControl]="checkControl"
          [id]="id"
          class="sh-checkbox sh-form-check-with-icon__check__input sh-form-group__input"
          [attr.aria-describedBy]="invalid ? describeLabelId : null"
          [attr.aria-invalid]="invalid"
          [shIndeterminate]="indeterminate$ | async"
          [attr.disabled]="disabled ? true : null"
          />
        <svg sh-icon class="sh-form-check-with-icon__check__icon" [name]="'angle-down'" [size]="sizes.SMALL" aria-hidden="true"></svg>
      </div>
      @if (label) {
        <label [for]="id" class="sh-form-check-with-icon__label">{{ label }}</label>
      }
    </div>
  </sh-droppanel-select>
</div>
